module.exports = __webpack_public_path__ + "static/bebas-9080bd7c08626e9c69aed91a7c64b939.eot";